/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import geolib from 'geolib'
import { Label, Button, Popup } from 'semantic-ui-react'
import get from 'lodash/get'

import firebase from '../../../../config/firebase'

import NeedSupportPopup from '../../../../lib/NeedSupportPopup'

export default class OrderDistanceInfo extends React.PureComponent {
  state = {
    popupVisible: false,
  }

  getDistance = () => {
    const { order } = this.props

    try {
      const { requestCoords } = order
      const deliveryLocation = get(order, 'etaInfo.info.legs.0.end_location', {})

      const userDeliveryLocation = {
        latitude: deliveryLocation.lat,
        longitude: deliveryLocation.lng,
      }

      const userOrderLocation = requestCoords

      const distance = geolib.getDistance(userOrderLocation, userDeliveryLocation)

      return distance
    } catch (e) {
      return 0
    }
  }

  redirectToMap = () => {
    const { order } = this.props
    const { requestCoords } = order
    const { latitude, longitude } = requestCoords

    this.setState({ popupVisible: false })

    const maps = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
    window.open(maps)
  }

  redirectToMapDirection = () => {
    const { order } = this.props
    const deliveryLocation = get(order, 'etaInfo.info.legs.0.end_location', {})
    const merchantLocation = get(order, 'etaInfo.info.legs.0.start_location', {})

    const maps = `https://www.google.com/maps/dir/?api=1&origin=${`${merchantLocation.lat},${
      merchantLocation.lng
    }`}&destination=${`${deliveryLocation.lat},${deliveryLocation.lng}`}`

    this.setState({ popupVisible: false })

    window.open(maps)
  }

  showOrderMap = () => {
    const { showOrderMap } = this.props
    this.setState({ popupVisible: false })

    showOrderMap()
  }

  onResolveSupport = () => {
    const { order } = this.props

    firebase
      .database()
      .ref(`orders/${order.key}/support_needed`)
      .remove()
  }

  onDistanceClick = () => {
    const { popupVisible } = this.state

    this.setState({ popupVisible: !popupVisible })
  }

  renderDropDown = () => {
    const { readOnly } = this.props
    const { popupVisible } = this.state

    const distance = this.getDistance()
    const distanceToDisplay = `${parseFloat(distance / 1000).toFixed(2)} km`

    return (
      <Popup
        wide
        on="click"
        hideOnScroll
        open={popupVisible}
        position="bottom center"
        onOpen={this.onDistanceClick}
        onClose={this.onDistanceClick}
        trigger={
          <Label color={distance > 100 ? 'orange' : 'green'} style={{ marginRight: 5, cursor: 'pointer' }}>
            {distanceToDisplay}
          </Label>
        }
      >
        <React.Fragment>
          <Button color="black" size="small" fluid onClick={this.redirectToMap}>
            Request Coords
          </Button>
        </React.Fragment>

        <div style={{ marginTop: 3 }}>
          <Button color="grey" size="small" fluid onClick={this.redirectToMapDirection}>
            Order Direction
          </Button>
        </div>

        {!readOnly && (
          <div style={{ marginTop: 3 }}>
            <Button color="grey" size="small" fluid onClick={this.showOrderMap}>
              Show Order Map
            </Button>
          </div>
        )}
      </Popup>
    )
  }

  renderCustomerNeedSupport = () => {
    const { order } = this.props
    const isNeedSupport = order.support_needed

    if (isNeedSupport) {
      return <NeedSupportPopup needSupport={isNeedSupport} onResolve={this.onResolveSupport} />
    }

    return null
  }

  render() {
    return (
      <div style={{ marginLeft: 3 }}>
        {this.renderDropDown()}
        {this.renderCustomerNeedSupport()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/OrderDistanceInfo.js